export const CheckPermissions = (product: any, capabilityToCheck: string, moduleToCheck: string): boolean => {

  let permissionResult = false;

  if (!product || !capabilityToCheck) return permissionResult;

  // eslint-disable-next-line
  product?.map((capability: any) => {
    // eslint-disable-next-line
    Object.keys(capability)?.map((capabilityName: string) => {
      if (capabilityName === capabilityToCheck) {
        // eslint-disable-next-line
        capability[capabilityName]?.map((module: string) => {
          // eslint-disable-next-line
          Object.keys(module)?.map((moduleName: string) => {
            if (moduleName === moduleToCheck) {
              permissionResult = true; // permission exist
            }
          })
        })
      }
    })
  })

  return permissionResult;
};